(() => {
  const placements = new WeakMap();
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function updateMobileBestseller() {
    const badge = document.querySelector('.prod__tag-bestseller');
    const media = document.querySelector('.sf-product-media__mobile');

    if (!badge || !media) return;

    const block = badge.closest('.main-product__block') || badge.parentElement;
    if (!block) return;

    if (mobileQuery.matches) {
      if (!placements.has(block)) {
        const marker = document.createComment('Auraglow mobile bestseller position');
        block.parentNode.insertBefore(marker, block);
        placements.set(block, marker);
      }

      block.classList.add('ag-mobile-bestseller');
      media.appendChild(block);
      return;
    }

    const marker = placements.get(block);
    if (marker && marker.parentNode) {
      marker.parentNode.insertBefore(block, marker.nextSibling);
      marker.remove();
    }

    placements.delete(block);
    block.classList.remove('ag-mobile-bestseller');
  }

  document.addEventListener('DOMContentLoaded', updateMobileBestseller);
  document.addEventListener('shopify:section:load', updateMobileBestseller);
  mobileQuery.addEventListener('change', updateMobileBestseller);
})();
